import { TallyMark3Icon } from './TallyMark3Icon';

/**
 * author: Michael Irigoyen
 * id 37C95AE2-2AB4-4800-9683-49806B29599A
 * name tally-mark-3
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tally-mark-3.svg
 * tags
 * - Math 
 */
export const Counting3Icon = TallyMark3Icon;
export default Counting3Icon